var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticalLinesDecoration = function SvgVerticalLinesDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 270,
    fill: "none",
    viewBox: "0 0 800 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FCD69D",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 10.961,
    d: "m7 65 20 133M64 70l11 128m44-103 6 129m48-94 1 134m52-139-2 134m55-174-6 134M332 7l-11 133"
  })));
};
export default SvgVerticalLinesDecoration;